module.exports = __webpack_public_path__ + "img/1.b75f27d5.jpg";